/** @jsx h */
/** @jsxFrag Fragment */
import { CSSProperties, h, HTMLAttributes } from "preact";
import { useState } from "preact/hooks";

export const uiDefaults = {
  "page/letter/width": "21cm",
  "page/letter/height": "29.7cm",
  "grid/size": "20px",
  "dot/image": "radial-gradient(rgba(180, 180, 180, 0.5) 10%, transparent 10%)",
  "dot/size": "var(--g) var(--g)",
  "dot/position": "calc(var(--g) / 2) calc(var(--g) / 2)",
} as const;

export const BaseStyle: CSSProperties = {
  "--page-letter-width": uiDefaults["page/letter/width"],
  "--page-letter-height": uiDefaults["page/letter/height"],
  "--g": uiDefaults["grid/size"],
};

export const StyleGrid: CSSProperties = {
  display: "grid",
  gridAutoRows: "var(--g)",
  gridAutoColumns: "var(--g)",
};

export const StyleDotBgGrid: CSSProperties = {
  backgroundImage: uiDefaults["dot/image"],
  backgroundSize: uiDefaults["dot/size"],
  backgroundPosition: uiDefaults["dot/position"],
};

export const StylePrintPage: CSSProperties = {
  width: "var(--page-letter-width)",
  height: "var(--page-letter-height)",
};

export const InlineCSS = {
  PageStyle: StylePrintPage,
  DotStyle: StyleDotBgGrid,
  gStyle: StyleGrid,
};
